import { UserAuthService, AuthenticationError } from '../services/auth/auth_user.service'
import { TokenService } from '../services/auth/token.service'
import { router } from '@/modules/router'
import {store} from "@/modules/store/store-module";
import {UserService} from "@/modules/partners/services/user.service";
import {User} from "@/modules/core/models";
// TODO not use still but it has to at some short point
// https://medium.com/@zitko/structuring-a-vue-project-authentication-87032e5bfe16

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  authenticationErrorCode: 0,
  authenticationError: '',
  refreshTokenPromise: null  // Holds the promise of the refresh token
};

const getters = {
  loggedIn: () => {
    return state.accessToken ? true : false;
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode
  },

  authenticationError: (state) => {
    return state.authenticationError
  },

  authenticating: (state) => {
    return state.authenticating
  }
};

const actions = {
  async login ({ state, commit, rootState }, { email, password }) {
    commit('loginRequest');

    try {
      const token = await UserAuthService.login(email, password);
      let user:User = await UserService.get_current_user();
      commit("setLoginUser",user, {root: true});
      commit('loginSuccess', token);

      // Redirect the user to the page he first tried to visit or to the home view
      // router.push(router.history.current.query.redirect || '/');
      // router.history is not build in, but the idea is good, take as reference :
      // https://stackoverflow.com/questions/43714773/how-can-i-get-the-vue-routers-history
      router.push('/');

      return true
    } catch (e) {
      if (e instanceof AuthenticationError) {
        await store.dispatch("snackbar/activate",
          {message: "El usuario o la contraseña introducida son incorrectas", code: 1} );
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
      }
      return false
    }
  },

  refreshToken({ commit, state }) {
    // If this is the first time the refreshToken has been called, make a request
    // otherwise return the same promise to the caller
    if(!state.refreshTokenPromise) {
      const p = UserAuthService.refreshToken();
      commit('refreshTokenPromise', p);

      // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
      // Clear the promise on error as well.
      p.then(
        response => {
          commit('refreshTokenPromise', null);
          commit('loginSuccess', response)
        },
        error => {
          commit('refreshTokenPromise', null)
        }
      )
    }

    return state.refreshTokenPromise
  },

  logout ({ commit }) {
    state.accessToken = null;
    UserAuthService.logout();
    commit('logoutSuccess');
    router.push('/');
  }
};

const mutations = {
  loginRequest (state) {
    state.authenticating = true;
    state.authenticationError = '';
    state.authenticationErrorCode = 0;
  },

  loginSuccess (state, accessToken) {
    state.accessToken = accessToken;
    state.authenticating = false
  },

  loginError (state, { errorCode, errorMessage }) {
    state.authenticating = false;
    state.authenticationErrorCode = errorCode;
    state.authenticationError = errorMessage;
  },

  logoutSuccess (state) {
    state.accessToken = ''
  },
  refreshTokenPromise(state, promise) {
    state.refreshTokenPromise = promise
  }
};

export const AuthStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
